import { useNavigate } from 'react-router-dom'
import { Button } from '@/components/ui/Button'
import { AppVersionLabel } from '@/components/AppVersionLabel'
import { TEST_ALARM_ID } from '@/config/constants'
import { tr } from '@/i18n'
import text from '@/styles/textStyles.module.css'
import s from './Landing.module.css'

/* ONE component for '/', '/welcome', '/home' and the 404 splat.
 *
 * welcome_widget.dart and home_widget.dart are byte-identical builds (only
 * class/route names differ):
 *   Scaffold(#F1F4F8) -> SafeArea(top) -> Stack:
 *     Align(0,0) -> Column(min):
 *       Text('Heart2Heart')            [Shrikhand 45, #FF77B7, ls 0]
 *       Padding(40,0,40,0) -> tagline  [PoppinsMedium 16 w500, lh 1.3, center]
 *       Padding(0,12,0,0)  -> FFButton('Go Test Tracking')
 *                                      [250x44, #FF77B7, r30, elevation 3]
 *     Align(1,1) -> AppVersionLabelWidget()
 *
 * Button: goNamed('Tracking', {id: testAlarmId}, fade 0ms) — goNamed is a
 * REPLACE, not a push, and 0 ms fade means no visible transition. */

export function Landing() {
  const navigate = useNavigate()

  return (
    <div className={s.scaffold}>
      <div className={s.center}>
        <p className={text.wordmark}>{tr.brand}</p>
        <p className={s.tagline}>{tr.landing.tagline}</p>
        <div className={s.buttonPad}>
          <Button
            text={tr.landing.goTestTracking}
            onClick={() => {
              navigate(`/app/${TEST_ALARM_ID}`, { replace: true })
            }}
          />
        </div>
      </div>
      <div className={s.versionCorner}>
        <AppVersionLabel />
      </div>
    </div>
  )
}
